// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    value: string;
}>;

export const DispatchSetSoldToValue: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ContactUs/SetSoldToValue",
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetSoldToValue];
const SetSoldToValue = createHandlerChainRunner(chain, "setSoldToValue");
export default SetSoldToValue;
